(function () {
  'use strict';

  var secondaryImageRequests = new WeakMap();

  function prepareSecondaryImage(card) {
    var image = card.querySelector('.product-card__image--secondary');
    if (!image) return Promise.resolve(false);
    if (secondaryImageRequests.has(image)) return secondaryImageRequests.get(image);

    image.loading = 'eager';
    image.setAttribute('fetchpriority', 'auto');

    var request = new Promise(function (resolve) {
      function finish(isReady) {
        if (isReady) card.classList.add('is-secondary-ready');
        resolve(isReady);
      }

      function decode() {
        if (image.naturalWidth < 1) {
          finish(false);
          return;
        }
        if (typeof image.decode !== 'function') {
          finish(true);
          return;
        }
        image.decode().then(function () {
          finish(true);
        }).catch(function () {
          finish(image.naturalWidth > 0);
        });
      }

      if (image.complete) {
        decode();
        return;
      }

      image.addEventListener('load', decode, { once: true });
      image.addEventListener('error', function () {
        finish(false);
      }, { once: true });
    });

    secondaryImageRequests.set(image, request);
    return request;
  }

  function setSecondaryState(card, visible) {
    var toggle = card.querySelector('[data-product-card-media-toggle]');
    if (!toggle) return;

    card.classList.toggle('is-secondary-visible', visible);
    toggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
    toggle.setAttribute(
      'aria-label',
      visible ? toggle.dataset.primaryLabel : toggle.dataset.secondaryLabel
    );
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;

    var media = event.target.closest('.product-card__media');
    if (!media) return;

    var card = media.closest('[data-product-card]');
    if (!card) return;

    prepareSecondaryImage(card).then(function (isReady) {
      if (isReady && media.matches(':hover')) setSecondaryState(card, true);
    });
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;

    var media = event.target.closest('.product-card__media');
    if (!media) return;
    if (event.relatedTarget && media.contains(event.relatedTarget)) return;

    var card = media.closest('[data-product-card]');
    if (card) setSecondaryState(card, false);
  }, { passive: true });

  document.addEventListener('focusin', function (event) {
    var card = event.target.closest('[data-product-card]');
    if (card) prepareSecondaryImage(card);
  });

  document.addEventListener('click', async function (event) {
    var toggle = event.target.closest('[data-product-card-media-toggle]');
    if (!toggle || !window.matchMedia('(max-width: 47.999em)').matches) return;

    event.preventDefault();

    if (toggle.getAttribute('aria-disabled') === 'true') return;

    var card = toggle.closest('[data-product-card]');
    if (!card) return;

    var showSecondary = !card.classList.contains('is-secondary-visible');

    if (showSecondary && !await prepareSecondaryImage(card)) return;

    if (showSecondary) {
      document
        .querySelectorAll('[data-product-card].is-secondary-visible')
        .forEach(function (activeCard) {
          if (activeCard !== card) setSecondaryState(activeCard, false);
        });
    }

    setSecondaryState(card, showSecondary);
  });
})();
